import { forwardRef } from 'react';

import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

interface DatePickerInputProps {
  defaultValue?: string | number;
  value?: string | number;
  onChange?: (value: number | undefined) => void;
  options?: { value: string }[];
  id?: string;
}
const DatePickerInput = forwardRef(
  (
    { defaultValue, value, onChange, options = [], id }: DatePickerInputProps,
    ref,
  ) => {
    function handleChange(value: dayjs.Dayjs | null) {
      if (value === null) {
        return onChange?.(undefined);
      }
      const epochValue = value.valueOf();
      if (isNaN(epochValue)) {
        return onChange?.(undefined);
      }
      onChange?.(epochValue);
    }

    // Convert epoch timestamp to Dayjs object or null
    const hasValue = value !== undefined && value !== null && value !== '';
    const parsedValue = hasValue ? Number(value) : NaN;
    const dateValue = Number.isFinite(parsedValue) ? dayjs(parsedValue) : null;

    return (
      <DatePicker
        value={dateValue}
        onChange={handleChange}
        sx={{ width: '100%' }}
        slotProps={{
          textField: {
            error: false,
          },
          actionBar: {
            actions: ['clear', 'today'],
          },
        }}
      />
    );
  },
);

DatePickerInput.displayName = 'DatePickerInput';

export default DatePickerInput;
